import { render } from "./EmergencyContactPrimary.vue?vue&type=template&id=4b0843b8&ts=true"
import script from "./EmergencyContactPrimary.ts?vue&type=script&lang=ts&external"
export * from "./EmergencyContactPrimary.ts?vue&type=script&lang=ts&external"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__